import React, { useContext, useState} from 'react';
import api from '../../services/api';
import { Context } from '../../services/contexts/StateContext';
import { format } from 'date-fns';

import { FunctModal } from '../../componentes/Functions';
import { descricaoParaTexto, montarDescricao } from '../descricaoEventoUtil';

//-------------------------------
function MontarFinanciamento(evento) {
    if (evento.tipoEvento !== 'Financiamento') return undefined;

    return {
        valorParcela: parseFloat(String(evento.valorParcela).replace(",", ".")),
        n_Parcelas: String(evento.numeroParcelas),
        vencimento: Number(evento.diaVencimento),
        primeiraParcela: evento.primeiraParcela ? new Date(evento.primeiraParcela + "T00:00:00-03:00") : undefined,
    };
}

export function ApiEvento() {
    const { state, dispatch } = useContext(Context);
    const { evento, terceiro, guincho } = state.evento;
    const { parametroInit, playmodal, listaPesquisa} = state.parametros;
    const { cliente, logado } = state.cliente;
    const { veiculo } = state.veiculo;

    const { FecharModal } = FunctModal();

    // ---------------------------
    async function AddSimplesEvento({dataEvento, tipoEvento, acao = 'criar evento'}) {
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, loadBola: true}
        });

        try {
            const eventoData = dataEvento || evento?.dataEvento;

            const res = await api.post('/evento', { 
                userCadastro: logado.idLogado || null,
                id_Veiculo: veiculo.id_Veiculo || null,
                id_Condutor: cliente.id_Cliente || null,
                id_EventoRef: evento.id_EventoRef || null,

                placa: veiculo.placa,
                tipoEvento: tipoEvento || evento.tipoEvento ,
                dataEvento: new Date(eventoData + "T00:00:00-03:00"),
                ocorrenciaBO: evento.ocorrenciaBO,
                descricao: montarDescricao(evento.descricao, null, logado.idLogado),
                tipoFile: "eventos",
                logs: {
                    idUsuario: logado.idLogado || null,
                    acao,
                    plataforma: logado.idLogado ? "interno" : "externo",
                    localizacao: {
                        latitude: evento.latitude ? evento.latitude : null,
                        longitude: evento.longitude ? evento.longitude : null,
                    }
                }

            });

            if (res.data) {
                dispatch({
                    type: 'set_Evento',
                    payload: { ...evento, id_Evento: res.data._id }
                });

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        listaEvento: res.data ? [res.data] : [],
                    }
                });

                setTimeout(() => {
                   alert('Evento Criado!');
                   PesqIdEvento(res.data._id);
                }, 1500);

                return res.data;
            }
            
        } catch (error) {
            alert(" ERRO AddSimplesEvento - Evento preenchido errado!");
            console.error('Erro em AddSimplesEvento:', error);
            
        } finally {
            setTimeout(() => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loadBola: false}
                });
            }, 2000);
        };
    };

    //----Add------------------------------------
    async function AddEvento() {
        if (!evento.id_Evento) {
            const requisitosPendentes = [];

            if (!veiculo.placa) requisitosPendentes.push('placa');
            if (!evento.tipoEvento) requisitosPendentes.push('tipo do evento');
            if (!evento.dataEvento) requisitosPendentes.push('data do evento');
            if (!Array.isArray(listaPesquisa.listaArquivos) || listaPesquisa.listaArquivos.length === 0) {
                requisitosPendentes.push('arquivo anexado');
            }

            if (requisitosPendentes.length > 0) {
                alert(`Preencha os requisitos obrigatórios: ${requisitosPendentes.join(', ')}.`);
                return;
            }

            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: true}
            });

            const eventoArray = {
                userCadastro: logado.idLogado,
                id_Veiculo: veiculo.id_Veiculo,
                id_Fornecedor: evento.id_Fornecedor ? evento.id_Fornecedor : null,
                id_EventoRef: evento.id_EventoRef ? evento.id_EventoRef : null,

                placa: veiculo.placa,
                nomeCliente: cliente.nome,
                tipo: evento.tipo,
                tipoEvento: evento.tipoEvento,
                codEvento: evento.placa + Math.floor(Math.random() * 1000),
                dataEvento: new Date(evento.dataEvento + "T00:00:00-03:00"),
                ocorrenciaBO: evento.ocorrenciaBO,
                descricao: montarDescricao(evento.descricao, null, logado.idLogado),
                inicioCReserva: new Date(evento.inicioCReserva + "T00:00:00-03:00"),
                fimCReserva: new Date(evento.fimCReserva + "T00:00:00-03:00"),

                origem: evento.origem,
                destino: evento.destino,
                orcamento: evento.orcamento ? parseFloat(String(evento.orcamento).replace(",", ".")) : 0,
                financiamento: MontarFinanciamento(evento),
                tipoFile: "eventos",

                logs: {
                    idUsuario: logado.idLogado || null,
                    acao: 'criar evento',
                    plataforma: logado.idLogado ? "interno" : "externo",
                    localizacao: {
                        latitude: evento.latitude ? evento.latitude : null,
                        longitude: evento.longitude ? evento.longitude : null,
                    }
                },

                guincho: {
                    origem: guincho.origem,
                    destino: guincho.destino,
                    km: guincho.km,
                },

                terceiro: {
                    tipo: terceiro.tipo,
                    placa: terceiro.placa,
                    chassi: terceiro.chassi,
                    anoMod: terceiro.anoMod,
                    montadora: terceiro.montadora,
                    modelo: terceiro.modelo,
                    cor: terceiro.cor,
                    valorFipe: terceiro.valorFipe,
                }
            };
            const formData = new FormData();
            formData.append("evento", JSON.stringify(eventoArray));

            let fileNew = listaPesquisa.listaArquivos;
            for (let i = 0; i < fileNew.length; i++) {
                formData.append(`file[${i}]`, fileNew[i]);
            };


            await api.post('/evento/addEventoArquivo',
                formData
            ).then(res => {
                if (res.data) {
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, loadBola: false}
                    });
                    
                    dispatch({
                        type: 'set_Evento',
                        payload: { ...evento, id_Evento: res.data.evento._id }
                    });

                    alert('Evento Salvo!');
                    FecharModal();
                    dispatch({ type: 'set_limparlistaPesquisa' });
                    PesqIdEvento(res.data.evento._id);
                }
            }).catch(erro => {
                alert(" ERRO - algo preenchido errado!");
                console.log(erro);
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loadBola: false}
                });
            });
        } else { alert("Evento já cadastrado, utilize a atualização!") }
    };

    // -----------------------------------
    async function AtualizarIdEvento({narracao, tipoFile, arquivosConvertidos}) {
        if (evento.id_Evento) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: true}
            });

            const eventoArray = {
                placa: veiculo.placa,
                id_Fornecedor: evento?.id_Fornecedor,
                tipo: evento?.tipo,
                tipoEvento: evento?.tipoEvento,
                dataEvento: new Date(evento.dataEvento + "T00:00:00-03:00"),
                ocorrenciaBO: evento?.ocorrenciaBO,
                descricao: montarDescricao(evento?.descricao, evento?.descricaoOriginal, logado.idLogado),
                narracao: evento?.narracao || narracao || "",
                status: evento?.status,

                logs: {
                    idUsuario: logado.idLogado || null,
                    acao: 'atualizar evento',
                    plataforma: logado.idLogado ? "interno" : "externo",
                    localizacao: {
                        latitude: evento.latitude ? evento.latitude : null,
                        longitude: evento.longitude ? evento.longitude : null,
                    }
                },

                origem: evento.origem,
                destino: evento.destino,
                orcamento: evento.orcamento ? evento.orcamento.toString().replace(",", ".") : evento.orcamento,
                fornecedor: evento.fornecedor,
                cnpjForne: evento.cnpjForne,
                chavePix: evento.chavePix,
                financiamento: MontarFinanciamento(evento),
                tipoFile: tipoFile || "eventos",

                inicioCReserva: new Date(evento.inicioCReserva + "T00:00:00-03:00"),
                fimCReserva: new Date(evento.fimCReserva + "T00:00:00-03:00"),

                guincho: {
                    origem: guincho?.origem,
                    destino: guincho?.destino,
                    km: guincho?.km,
                },

                terceiro: {
                    tipo: terceiro?.tipo,
                    placa: terceiro?.placa,
                    chassi: terceiro?.chassi,
                    anoMod: terceiro?.anoMod,
                    montadora: terceiro?.montadora,
                    modelo: terceiro?.modelo,
                    cor: terceiro?.cor,
                    valorFipe: evento?.valorFipe,
                    dataPart: new Date(evento.dataPart + "T00:00:00-03:00"),
                    valorPart: evento?.valorPart,
                },
                data_modificado: Date.now(),
            };

            // Remover campos nulos
            Object.keys(eventoArray).forEach(key => {
                if (eventoArray[key] === null || eventoArray[key] === undefined || eventoArray[key] === "") {
                    delete eventoArray[key];
                }
            });

            const formData = new FormData();
            formData.append("evento", JSON.stringify(eventoArray));

            let fileNew = arquivosConvertidos || listaPesquisa.listaArquivos;
            for (let i = 0; i < fileNew.length; i++) {
                formData.append(`file[${i}]`, fileNew[i]);
            };

            return api.put(`/evento/atualizar/${evento.id_Evento}`,
                formData
            ).then(async res => {
                if (playmodal.playModalEven) {
                    FecharModal();
                    dispatch({ type: 'set_limparlistaPesquisa' });
                };

                alert('Evento Atualizado!');
                PesqIdEvento(evento.id_Evento);

            }).catch((error) => {
                alert("Ocorreu um erro");
                
            }).finally(()=>{
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loadBola: false}
                });
            });
        } else { alert("Nenhum evento selecionado para atualizar!")}
    };
    
    // -----------------------------------
    async function AtualizarSimples(extras = {}) {
        if (evento.id_Evento) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: true}
            });

            const campos = {
                placa: veiculo.placa,
                id_Veiculo: veiculo.id_Veiculo,
                tipoEvento: evento.tipoEvento,
                dataEvento: new Date(evento.dataEvento + "T00:00:00-03:00"),
                narracao: evento.narracao,

                dataPart: new Date(evento.dataPart + "T00:00:00-03:00"),
                valorPart: evento?.valorPart,
                detalhePart: evento?.detalhePart,

                orcamento: evento.orcamento ? evento.orcamento.toString().replace(",", ".") : evento.orcamento,
                financiamento: MontarFinanciamento(evento),

                id_Condutor: cliente.id_Cliente,
                descricao: montarDescricao(evento.descricao, evento.descricaoOriginal, logado.idLogado),
                tipoFile: "eventos",
                ...extras,
                logs: {
                    idUsuario: logado.idLogado || null,
                    acao: 'atualizar evento',
                    plataforma: logado.idLogado? "interno" : "externo",
                    localizacao: {
                        latitude: evento.latitude ? evento.latitude : null,
                        longitude: evento.longitude ? evento.longitude : null,
                    }
                }
            };

            // Remover campos nulos
            Object.keys(campos).forEach(key => {
                if (campos[key] === null || campos[key] === undefined || campos[key] === "") {
                    delete campos[key];
                }
            });

            await api.put(`/evento/atualizarSimples/${evento.id_Evento}`,
                campos
            ).then(res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loadBola: false}
                });
                
                if (playmodal.playModalEven) {
                    FecharModal();
                    dispatch({ type: 'set_limparlistaPesquisa' });
                };

                alert('Evento Atualizado!');
                PesqIdEvento(evento.id_Evento);
            }).catch((error) => {
                alert("Ocorreu um erro");
            });
        }
    };

    // -----------------------------------
    async function BuscaTodosEventos() {
        FecharModal();
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, loading: true, detalhesLista: false }
        });

        await api.post('/evento/Tudo', {
            placa: listaPesquisa.nomeItem, 
            user: logado.idLogado, 
        })
        .then(res => {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: false }
            });

            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaEvento: res.data.length > 0 ? res.data : [],
                }
            });

        }).catch((error) => {
            alert("Ocorreu um erro ao buscar os items");
        });
    };
    
    // -----------------------------------------
    async function PesqPorData(inicio, fim, porForn, porTipo, porUsuario, tipoData, callback) {
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, loading: true, detalhesLista: false }
        });

        const aplicarResultado = (res) => {
            const dados = Array.isArray(res?.data) ? res.data : [];

            if (typeof callback === 'function') {
                callback(dados);
            }

            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: false }
            });

            dispatch({
                type: 'set_ListaPesquisa',
                payload: { ...listaPesquisa, listaEvento: dados }
            });

            return dados;
        };

        const payloadBase = {
            placa: listaPesquisa.nomeItem,
            inicio: inicio,
            fim: fim,
            user: logado.idLogado,
            tipoData: tipoData,
        };

        if(tipoData === "PAGAMENTO"){
            return PesqTudoDataPagamento(inicio, fim, porForn, porTipo, porUsuario, callback);
        }

        if(porForn && listaPesquisa.id_nomeForn){
            return await api.post(`/evento/Tudo/DataForn`, {
                ...payloadBase,
                forn: listaPesquisa.id_nomeForn,
            })
            .then(aplicarResultado)
            .catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });
        }

        else if(porTipo && evento.tipoEvento){
            return await api.post(`/evento/Tudo/DataTipo`, {
                ...payloadBase,
                tipo: evento.tipoEvento,
            })
            .then(aplicarResultado)
            .catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });

        }
        
        else if(porUsuario && listaPesquisa.id_nomeUser){
            return await api.post(`/evento/Tudo/DataUser`, {
                ...payloadBase,
                user: listaPesquisa.id_nomeUser,
            })
            .then(aplicarResultado)
            .catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });

        } else {
            return await api.post(`/evento/porData`, payloadBase)
            .then(aplicarResultado)
            .catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });
        }

    };

    // -----------------------------------------
    async function PesqTudoDataApagar(inicio, fim, Tudo, porForn, porTipo, porUsuario, tipoData, callback, filtros = {}) {
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, loading: true, detalhesLista: false }
        });

        const aplicarResultado = (res) => {
            const dados = Array.isArray(res?.data) ? res.data : [];

            if (typeof callback === 'function') {
                callback(dados);
            }

            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: false }
            });

            dispatch({
                type: 'set_ListaPesquisa',
                payload: { ...listaPesquisa, listaEvento: dados }
            });

            return dados;
        };

        const payloadBase = {
            placa: listaPesquisa.nomeItem,
            inicio: inicio,
            fim: fim,
            user: logado.idLogado,
            tipoData: tipoData,
            Tudo:Tudo,
        };

        if (Array.isArray(filtros.tipos) && filtros.tipos.length > 0) {
            payloadBase.tipos = filtros.tipos;
        }

        if (Array.isArray(filtros.excluirTipos) && filtros.excluirTipos.length > 0) {
            payloadBase.excluirTipos = filtros.excluirTipos;
        }

        if(tipoData === "PAGAMENTO"){
            return PesqTudoDataPagamento(inicio, fim, Tudo, porForn, porTipo, porUsuario, callback);
        };

        return await api.post(`/evento/Tudo/DataApagar`, payloadBase)
        .then(aplicarResultado)
        .catch((error) => {
            alert("Ocorreu um erro ao buscar os items");
            return [];
        });
    };

    // -----------------------------------------
    async function PesqTudoDataPagamento(inicio, fim, Tudo, porForn, porTipo, porUsuario, callback) {
        const aplicarResultado = (res) => {
            const dados = (Array.isArray(res?.data) ? res.data : []).filter((item) => item?.dataPag);

            if (typeof callback === 'function') {
                callback(dados);
            }

            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: false }
            });

            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaEvento: dados
                }
            });

            return dados;
        };

        if(porForn && listaPesquisa.id_nomeForn){
            return await api.post(`/evento/Tudo/DataForn`, {
                user: logado.idLogado,
                placa: listaPesquisa.nomeItem,
                forn: listaPesquisa.id_nomeForn,
                inicio: inicio,
                fim: fim,
                tipoData: "PAGAMENTO",
                Tudo: Tudo
            })
            .then(aplicarResultado)
            .catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });
        }

        else if(porTipo && evento.tipoEvento){
            return await api.post(`/evento/Tudo/DataTipo`, {
                placa: listaPesquisa.nomeItem,
                inicio: inicio,
                fim: fim,
                tipo: evento.tipoEvento,
                user: logado.idLogado,
                tipoData: "PAGAMENTO",
                Tudo:Tudo
                
            })
            .then(aplicarResultado)
            .catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });

        }
        
        else if(porUsuario && listaPesquisa.id_nomeUser){
            return await api.post(`/evento/Tudo/DataUser`, {
                user: listaPesquisa.id_nomeUser,
                inicio: inicio,
                fim: fim,
                tipoData: "PAGAMENTO",
                Tudo: Tudo
                
            })
            .then(aplicarResultado)
            .catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });

        } else {
            return await api.post(`/evento/porData`, {
                placa: listaPesquisa.nomeItem,
                inicio: inicio,
                fim: fim,
                user: logado.idLogado,
                tipoData: "PAGAMENTO",
                Tudo:Tudo
            })
            .then(aplicarResultado)
            .catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });
        }

    };

    //--Pesquisar por Placa/Fornecedor/Tipo--
    async function PesquisarEvento(placa, porForn, porTipo) {
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, loading: true}
        });

        if(placa && porForn && listaPesquisa.id_nomeForn){
            await api.post(`/evento/Tudo/Fornecedor`,{
                placa: placa,
                forn: listaPesquisa.id_nomeForn
            })
            .then(res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false }
                });

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaEvento: res.data }
                });
            }).catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
            });
        }

        else if(placa && porTipo && evento.tipoEvento){
            await api.post(`/evento/Tudo/Tipo`, {
                placa: placa,
                tipo: evento.tipoEvento,
            })
            .then(res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false }
                });

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaEvento: res.data }
                });
            }).catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
            });

        } 

        else if(placa){
            return await api.get(`/evento/placa/${placa}`)
            .then(res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false }
                });

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaEvento: res.data }
                });

                return Array.isArray(res.data) ? res.data : [];
            }).catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });
        }

        else if(porForn && listaPesquisa.id_nomeForn){
            await api.post(`/evento/Tudo/Fornecedor`,{
                forn: listaPesquisa.id_nomeForn
            })
            .then(res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false }
                });

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaEvento: res.data }
                });
            }).catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });
        }

        else if(porTipo && evento.tipoEvento){
            await api.post(`/evento/Tudo/Tipo`,{
                tipo: evento.tipoEvento,
            })
            .then(res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false }
                });

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaEvento: res.data }
                });
            }).catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                return [];
            });

        } else {
            BuscaTodosEventos()
        };
    };

    //--Pesquisar Evento SEM DATA por UserCadastro
    async function PesquisaUserCad(idUser) {
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, loading: true}
        });

        if(listaPesquisa.id_nomeUser){
            await api.post(`/evento/Tudo/userCadastro`,{
                idUser: idUser,
            })
            .then(res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false }
                });

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaEvento: res.data }
                });
            }).catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
            });
        }
    };


    //--Pesquisar Evento por id-----------------
    async function PesqIdEvento(id_Evento, limparCamposPagamento = false) {
        if (id_Evento) {
            await api.get(`/evento/id/${id_Evento}`)
                .then(res => {
                    if (playmodal.playModalEven) {
                        FecharModal();
                    };

                    // ---
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: {
                            ...listaPesquisa,
                            listaEvento: [res.data],
                            listaPagamentos: res.data.pagamentos,
                            listaArquivos: [],
                            selectItem: '',
                            
                        }
                    });

                    // ---
                    dispatch({
                        type: 'set_Evento',
                        payload: {
                            ...evento,
                            "id_Evento": res.data._id,
                            "nomeCliente": res.data?.id_Veiculo?.id_Cliente?.nome,
                            "id_Fornecedor": res.data?.id_Fornecedor,
                            "tipo": res.data.tipo,
                            "tipoEvento": res.data.tipoEvento,
                            "codEvento": res.data.codEvento,
                            "dataEvento": res.data.dataEvento ? String(res.data.dataEvento).slice(0, 10) : '',
                            "ocorrenciaBO": res.data.ocorrenciaBO,
                            "descricao": descricaoParaTexto(res.data.descricao),
                            "descricaoOriginal": res.data.descricao,
                            "status": res.data.status,
                            "placa": res.data.placa,
                            "orcamento": res.data.orcamento ? res.data.orcamento : 0,
                            "numeroParcelas": res.data.financiamento?.n_Parcelas || "",
                            "valorParcela": res.data.financiamento?.valorParcela || "",
                            "diaVencimento": res.data.financiamento?.vencimento || "",
                            "primeiraParcela": res.data.financiamento?.primeiraParcela ? format(new Date(res.data.financiamento.primeiraParcela), 'yyyy-MM-dd') : "",
                            "inicioCReserva": res.data.inicioCReserva ? format(new Date(res.data.inicioCReserva), 'yyyy-MM-dd') : '',
                            "fimCReserva": res.data.fimCReserva ? format(new Date(res.data.fimCReserva), 'yyyy-MM-dd') : '',

                            "dataPart": res.data.dataPart ? format(new Date(res.data.dataPart), 'yyyy-MM-dd') : '',
                            "valorPart": res.data.valorPart,
                            "detalhePart": res.data.detalhePart,
                            "dataPag": !limparCamposPagamento && res.data.dataPag ? format(new Date(res.data.dataPag), 'yyyy-MM-dd') : '',
                            "valorPag": res.data.valorPag,
                            "valorPagamento": '',
                            "formaPag": limparCamposPagamento ? '' : res.data.formaPag,

                            "arquivos": res.data.arquivos.reverse()
                        }
                    });

                    // ---
                    dispatch({
                        type: 'set_Guincho',
                        payload: { 
                            ...guincho, 
                            origem: res.data.guincho?.origem || "",
                            destino: res.data.guincho?.destino || "",
                            km: res.data.guincho?.km || "",
                        }
                    });

                    // ---
                    if (res.data.terceiro) {
                        dispatch({
                            type: 'set_Terceiro',
                            payload: {
                                ...terceiro,
                                "tipo": res.data.terceiro.tipo,
                                "placa": res.data.terceiro.placa,
                                "chassi": res.data.terceiro.chassi,
                                "anoMod": res.data.terceiro.anoMod,
                                "montadora": res.data.terceiro.montadora,
                                "modelo": res.data.terceiro.modelo,
                                "cor": res.data.terceiro.cor,
                                "valorFipe": res.data.terceiro.valorFipe,
                                "anexoCNH": res.data.terceiro.anexoCNH,
                            }
                        });
                    };
                    // ---
                })
        }
    };

    //----------Pesquisar Evento por codEvento----
    async function PesqEventoCod() {
        if (parametroInit.filtroCodigoEven) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: true }
            });

            await api.get(`/evento/filtrar/${parametroInit.filtroCodigoEven}`)
                .then(res => {
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, loading: false }
                    });
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaEvento: res.data }
                    });
                })
        } else {
            BuscaTodosEventos();
        };

        dispatch({
            type: 'set_cliente',
            payload: { ...cliente, id_Cliente: '' }
        });
        dispatch({
            type: 'set_veiculo',
            payload: { ...veiculo, id_Veiculo: '' }
        });
        dispatch({
            type: 'set_Evento',
            payload: { ...evento, id_Evento: '' }
        });
        dispatch({
            type: 'SET_PLAYMODAL',
            payload: { ...playmodal, playModalEven: false }
        });
    };


    // -----------------------------------
    async function BaixarEvento(seteditPag, valorPagamento, descricaoPagamento) {
        const orcamento = Number(evento.orcamento || 0);
        const pagamentosAtuais = Array.isArray(listaPesquisa.listaPagamentos) ? listaPesquisa.listaPagamentos : [];
        const arquivosNovos = Array.isArray(listaPesquisa.listaArquivos) ? listaPesquisa.listaArquivos : [];
        const arquivosPagamento = (Array.isArray(evento.arquivos) ? evento.arquivos : [])
            .filter(arquivo => /pagamento/i.test(arquivo));
        const isFinanciamento = evento.tipoEvento === 'Financiamento';
        const valorParcelaFinanciamento = Number(String(evento.valorParcela).replace(",", "."));
        const principalPago = pagamentosAtuais.reduce((total, pagamento) => {
            const valorPago = Math.max(Number(pagamento?.valor ?? pagamento?.valorPG ?? 0), 0);
            const valorPrincipal = isFinanciamento && valorParcelaFinanciamento > 0
                ? Math.min(valorPago, valorParcelaFinanciamento)
                : valorPago;
            return total + valorPrincipal;
        }, 0);
        const valorParcela = Number(valorPagamento);
        const valorPrincipalPagamento = isFinanciamento && valorParcelaFinanciamento > 0
            ? Math.min(valorParcela, valorParcelaFinanciamento)
            : valorParcela;
        const saldoAtual = Math.max(orcamento - principalPago, 0);

        if (evento.dataPag && evento.id_Evento && evento.formaPag && Number.isFinite(valorParcela) && valorParcela > 0 && valorPrincipalPagamento <= saldoAtual && (arquivosNovos.length > 0 || arquivosPagamento.length > 0)) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: true}
            });

            const novoPagamento = {
                data: new Date(evento.dataPag + 'T00:00:00'),
                valor: valorParcela,
                tipo: evento.formaPag,
                descricao: descricaoPagamento || '',
            };

            const eventoArray = {
                placa: evento.placa,
                pagamento: novoPagamento,
                tipoFile: "pagamentos",
                logs: {
                    idUsuario: logado.id_Cliente,
                    acao: 'pago evento',
                    plataforma: "interno",
                    localizacao: {
                        latitude: veiculo.latitude ? veiculo.latitude : null,
                        longitude: veiculo.longitude ? veiculo.longitude : null,
                    }
                }
            };

            const formData = new FormData();
            formData.append("evento", JSON.stringify(eventoArray));

            let fileNew = arquivosNovos;
            for (let i = 0; i < fileNew.length; i++) {
                formData.append(`file[${i}]`, fileNew[i]);
            };

            return api.put(`/evento/atualizar/${evento.id_Evento}`,
                formData
            ).then(async res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loadBola: false}
                });

                if (res.data.error) {
                    const mensagemErro = typeof res.data.error === 'string'
                        ? res.data.error
                        : res.data.error.msg || 'A API recusou o pagamento.';
                    throw new Error(mensagemErro);

                } else{
                    if (typeof seteditPag === 'function') seteditPag(false);
                    alert('Pagamento Confirmando!');
                    try {
                        await PesqIdEvento(evento.id_Evento, true);
                    } catch (error) {
                        console.error('Pagamento salvo, mas não foi possível atualizar os dados do evento.', error);
                    }
                    return true;
                }

            }).catch((error) => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loadBola: false}
                });
                throw error;
            });
        } else {
            alert("Preencha todos os campos, incluindo os arquivos!");
            return false;
        }
    };

    // -----------------------------------
    async function AddArquivosEvento() {
        if (((evento.id_Evento && evento.placa) && listaPesquisa.listaArquivos.length > 0 || evento.arquivos.length > 0)) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: true}
            });

            const eventoArray = {
                placa: evento.placa,
                tipoFile: "eventos",
                logs: {
                    idUsuario: logado.idLogado || null,
                    acao: 'adicionar arquivos evento',
                    plataforma: logado.idLogado ? "interno" : "externo",
                    localizacao: {
                        latitude: evento.latitude ? evento.latitude : null,
                        longitude: evento.longitude ? evento.longitude : null,
                    }
                },
            };

            const formData = new FormData();
            formData.append("evento", JSON.stringify(eventoArray));

            let fileNew = listaPesquisa.listaArquivos;
            for (let i = 0; i < fileNew.length; i++) {
                formData.append(`file[${i}]`, fileNew[i]);
            };

            await api.put(`/evento/addArquivos/${evento.id_Evento}`,
                formData
            ).then(res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loadBola: false}
                });

                if (res.data.error) {
                    alert("ERROO", res.data.error.msg)

                } else{
                    PesqIdEvento(evento.id_Evento);
                    alert('Arquivos Salvos!'); 
                }

            }).catch((error) => {
                alert("Ocorreu um erro");
            });
        } else { alert("Preencha todos os campos, incluindo os arquivos!") };
    };

    // delete arquivo
    async function DeleteArquivo_S3(t) {
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, loadBola: true}
        });

        await api.put(`/evento/deletarArquivo_S3`, {
            id_evento: evento.id_Evento,
            caminho: t,
            logs: {
                idUsuario: logado.id_Cliente,
                acao: 'delete arquivo evento',
                plataforma: "interno",
                localizacao: {
                    latitude: veiculo.latitude ? veiculo.latitude : null,
                    longitude: veiculo.longitude ? veiculo.longitude : null,
                }
            }

        }).then(res => {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: false}
            });
            
            if (res.data.error) {
                alert(res.data.message)
            } else {
                PesqIdEvento(evento.id_Evento);
                alert('Arquivo Excluido!');
            }
        }).catch((error) => {
            alert("Ocorreu um erro");
        });
    };
    
    
    //----Add----------------------------------
    async function AddFornecedor() {
        await api.post('/evento/addFornecedor', {
            userCadastro: logado.idLogado,
            nome: evento.fornecedor,
            cnpj: evento.cnpjForne,
            chavePix: evento.chavePix,
            logs: {
                idUsuario: logado.id_Cliente,
                acao: 'add fornecedor evento',
                plataforma: "interno",
                localizacao: {
                    latitude: veiculo.latitude ? veiculo.latitude : null,
                    longitude: veiculo.longitude ? veiculo.longitude : null,
                }
            }

        }).then(res => {
            if (res.data.error) {
                alert(res.data.error.msg)

            } else {
                dispatch({
                    type: 'set_Evento',
                    payload: {
                        ...evento,
                        id_Fornecedor: res.data._id,
                        fornecedor: res.data.nome,
                        chavePix: res.data.chavePix,
                    }
                });
                alert('Fornecedor OK!!!');
            }
        }).catch(erro => console.error(erro))
    };

    //--Pesquisar por id-----------------
    async function PesqIdFornecedor(id_Fornecedor) {
        if (id_Fornecedor) {
            await api.get(`/evento/id/fornecedor/${id_Fornecedor}`)
                .then(res => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: {
                            ...listaPesquisa,
                            listaFornecedor: [res.data],
                        }
                    });
                })
        }
    };
    //-------Pesquisar por CNPJ ou Nome---------
    async function PesqFornecedor(cnpj) {
        if (cnpj) {
            await api.get(`/evento/fornecedor/${cnpj}`)
                .then(res => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: {
                            ...listaPesquisa,
                            listaFornecedor: res.data.length > 0 ? res.data.map(item => ({nome: item.nome, id: item._id})) : [],
                            alertaNovo: res.data.length > 0 ? false : true
                        }
                    });
                })
        }
    };

    //-------Pesquisar por Vistoria PLACA---------
    async function PesqVistoriaPlaca(placa) {
        dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: true }
            });

        if (placa) {
            await api.get(`/evento/vistoria/${placa}`)
                .then(res => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaEvento: res.data }
                    });


                }).catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
                
            }).finally( ()=>{
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false}
                });
            });
        }
    };

    //-------Pesquisar eventos por placa---------
    async function PesquisarEventosPorPlaca(placa, { tiposEvento, statusExcluir } = {}) {
        if (!placa?.trim()) return [];

        const resposta = await api.post('/evento/Tudo', {
            Tudo: true,
            placa: placa.trim(),
            tiposEvento,
            statusExcluir,
        });

        return Array.isArray(resposta.data) ? resposta.data : [];
    }

    //-------Salvar tarefas de um evento---------
    async function SalvarTarefasEvento(idEvento, tarefas) {
        if (!idEvento) return null;

        const resposta = await api.put(`/evento/atualizarSimples/${idEvento}`, {
            tarefas,
            logs: {
                idUsuario: logado.id_Cliente,
                acao: 'salvar tarefas evento',
                plataforma: "interno",
                localizacao: {
                    latitude: veiculo.latitude ? veiculo.latitude : null,
                    longitude: veiculo.longitude ? veiculo.longitude : null,
                }
            }
        });

        return resposta.data;
    }

    return {
        AddSimplesEvento, AddEvento, PesqIdFornecedor, PesqFornecedor, AddFornecedor, AtualizarIdEvento, DeleteArquivo_S3, PesqVistoriaPlaca, PesqTudoDataApagar,
        AtualizarSimples, BaixarEvento, AddArquivosEvento, PesqEventoCod, BuscaTodosEventos, PesqPorData, PesquisarEvento, PesquisaUserCad, PesqIdEvento,
        PesquisarEventosPorPlaca, SalvarTarefasEvento
    }

}
